import { useEffect, useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { Spinner } from '../shared';
import { useAuth } from '../../contexts/AuthContext';
import { useProperty } from '../../contexts/PropertyContext';
import { usePropertyLoader } from '../../hooks/usePropertyLoader';
import { useMobileBreakpoint } from '../../hooks/useMobileBreakpoint';

export function Layout() {
  const { adminUser } = useAuth();
  const { setAvailableProperties } = useProperty();
  const { properties, loading } = usePropertyLoader();
  const isMobile = useMobileBreakpoint();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Sync loaded properties into PropertyContext
  useEffect(() => {
    setAvailableProperties(properties);
  }, [properties, setAvailableProperties]);

  // Close sidebar when switching to desktop
  useEffect(() => {
    if (!isMobile) setSidebarOpen(false);
  }, [isMobile]);

  if (loading) {
    return <Spinner size="lg" label="Loading..." className="h-screen" />;
  }

  return (
    <div className="flex h-screen bg-surface-50">
      {/* Desktop sidebar */}
      {!isMobile && (
        <div className="flex-shrink-0">
          <Sidebar />
        </div>
      )}

      {/* Mobile sidebar overlay */}
      {isMobile && sidebarOpen && (
        <div className="fixed inset-0 z-40 flex">
          <div
            className="fixed inset-0 bg-black/50"
            onClick={() => setSidebarOpen(false)}
          />
          <div className="relative z-50 w-64 transition-transform">
            <Sidebar mobile onClose={() => setSidebarOpen(false)} />
          </div>
        </div>
      )}

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
          <Header onMenuClick={() => setSidebarOpen(true)} isMobile={isMobile} />
          {adminUser?.needs2FASetup && (
            <div className="bg-warning-50 border-b border-warning-100 px-4 py-2.5 text-sm text-warning-700 text-center">
              Your role requires two-factor authentication.{' '}
              <Link to="/account/security" className="font-medium underline hover:text-warning-700">
                Set up 2FA
              </Link>
            </div>
          )}
          <main className="flex-1 overflow-y-auto p-4 md:p-6">
            <Outlet />
          </main>
        </div>
    </div>
  );
}
